import Vue from "vue";

export const toastState = Vue.observable({ toasts: [] });

let uid = 0;
const DEFAULT_DURATION = 4000;

function push({
    action = null,
    duration = DEFAULT_DURATION,
    icon = "",
    persistent = false,
    position = "bottom-right",
    text = "",
    title = ""
}) {
    uid += 1;
    const id = uid;
    toastState.toasts.push({
        id,
        title,
        text,
        icon,
        position,
        persistent,
        action
    });
    if (!persistent) {
        setTimeout(() => remove(id), duration);
    }
    return id;
}

export function remove(id) {
    const index = toastState.toasts.findIndex((item) => item.id === id);
    if (index !== -1) toastState.toasts.splice(index, 1);
}

export const toast = {
    show(options) {
        return push(options);
    },
    success(options) {
        return push({ icon: "✅", ...options });
    },
    info(options) {
        return push({ icon: "ℹ️", ...options });
    },
    close(id) {
        remove(id);
    }
};

export default {
    install(VueGlobal) {
        VueGlobal.prototype.$toast = toast;
    }
};
